module.exports = __webpack_public_path__ + "static/images/callout_2.dcd30413986ee8da5f5b08c223e1bf43.jpg";